class Sticky {
    constructor(element) {
        this.el = element;
        this.header = document.querySelector("header");
        this.revealed = false;

        this.init();
    }

    init() {
        this.fixElement();
        this.handleReveal(); // fade in after scroll past header + 50px
    }

    fixElement() {
        this.el.style.setProperty("--true-height", this.el.offsetHeight + "px");
        this.el.style.setProperty("--true-width", this.el.offsetWidth + "px");

        window.addEventListener("scroll", () => {
            const elementTop = this.el.getBoundingClientRect().top;

            if (elementTop <= 0) {
                this.el.classList.add("stuck");
            } else {
                this.el.classList.remove("stuck");
            }
        });
    }

    handleReveal() {
        const checkReveal = () => {
            if (this.revealed) return;

            const headerBottom = this.header.getBoundingClientRect().bottom;

            // Reveal only after scrolling 50px beyond the bottom of the header
            if (headerBottom <= -250) {
                this.el.classList.add("is-visible");
                this.revealed = true;
            }
        };

        window.addEventListener("scroll", checkReveal);
        checkReveal(); // initial check on load
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const stickyElements = document.querySelectorAll("[data-sticky]");

    stickyElements.forEach((element) => {
        element.classList.remove("is-visible"); // hide by default
        new Sticky(element);
    });
});
